import ENUM from '../ENUM'

export default function () {
    return {
        kind: 'MultiQuestionSlide',
        filters: [
            {
                name: ENUM().ranking,
                // first item in array is the default
                options: [
                    {
                        label: ENUM().noRanking,
                        value: 'noRanking',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().lowToHigh,
                        value: 'lowToHigh',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().highToLow,
                        value: 'highToLow',
                        name: ENUM().ranking,
                    },
                    {
                        label: ENUM().aToZ,
                        value: 'aToZ',
                        name: ENUM().ranking,
                    },
                ],
            },
            {
                name: ENUM().comparisonSurveyIds,
            },
            {
                name: ENUM().removeBaseLimit,
            },
            {
                name: ENUM().display,
                options: [
                    {
                        label: ENUM().average,
                        value: 'average',
                        name: ENUM().display,
                    },
                    {
                        label: ENUM().top2,
                        value: 'top2',
                        name: ENUM().display,
                    },
                ],
            },
        ],
        references: [ENUM().childPageQuestionId],
    }
}
